import { Rarity } from "@/types/cat";
import { cn } from "@/lib/utils";

const rarityConfig: Record<
  Rarity,
  { label: string; bg: string; text: string; border: string }
> = {
  common: {
    label: "Common",
    bg: "bg-slate-500/20",
    text: "text-slate-300",
    border: "border-slate-500/50",
  },
  rare: {
    label: "Rare",
    bg: "bg-blue-500/20",
    text: "text-blue-300",
    border: "border-blue-500/50",
  },
  legendary: {
    label: "Legendary",
    bg: "bg-purple-500/20",
    text: "text-purple-300",
    border: "border-purple-500/50",
  },
  mythic: {
    label: "Mythic",
    bg: "bg-amber-500/20",
    text: "text-amber-300",
    border: "border-amber-500/50",
  },
};

interface RarityBadgeProps {
  rarity: Rarity;
  className?: string;
  showLabel?: boolean;
}

export function RarityBadge({
  rarity,
  className,
  showLabel = true,
}: RarityBadgeProps) {
  const config = rarityConfig[rarity];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold",
        config.bg,
        config.text,
        config.border,
        className
      )}
    >
      {showLabel && config.label}
    </span>
  );
}
